"use strict";

// @ts-check
var CountryPickerDropdown = require('./dropdown/country-picker-dropdown')["default"];

var CountryPickerModal = require('./modal/country-picker-modal')["default"];

var CountryPickerAdvanced = require('./advanced/country-picker-advanced')["default"];
/** @typedef {import('./types').CountryPickerOptions} CountryPickerOptions */

/**
 * @param {CountryPickerOptions} optionsObj
 */


function createCountryPicker() {
  var optionsObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  switch (optionsObj.type) {
    case 'advanced':
      return CountryPickerAdvanced.create(optionsObj);

    case 'modal':
      return CountryPickerModal.create(optionsObj);

    default:
      return CountryPickerDropdown.create(optionsObj);
  }
}

module.exports = {
  createCountryPicker: createCountryPicker
};


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/country-picker/lib/index.js
// module id = 540
// module chunks = 0 1